import { render, staticRenderFns } from "./MiniapolyProduct.vue?vue&type=template&id=60ac08f0&"
import script from "./MiniapolyProduct.vue?vue&type=script&lang=js&"
export * from "./MiniapolyProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports